<template> 
  <div style="background-color:white">
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <img src="@/assets/products/muende_bwino_2.jpg" alt="" height="380" />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <div style="padding-top:80px;padding-left:0%;">
          <div>
            <p style="font-size:36px;padding:0px;margin:0px;font-weight:200;font-family:Roboto">Muende Bwino Personal Cover</p>
            
          </div>
          <div style="padding-top:20px">
            
            <p>This is a local Travel Insurance Policy which provides payout for death, Injuries and a 
              component of hospital bills following a road traffic accident whilst travelling on Zambian roads.</p>
              
            <h5>Benefits:</h5>
            <p><span class="mdi mdi-check"> For Injury or death per event/aggregate</span></p>
            <p><span class="mdi mdi-check"> Emergency medical, First Aid and ambulance fees following a road traffic accident</span></p>          
          </div>
          <div style="padding-left:25%;padding-top:15px">
            <v-btn
              color="primary"
              rounded
              outlined
              large
              @click="openDrawer(5)"        
            >
              Get a Quote
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    

  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'MuendeBwino',
    components: {
      
    },
    data() {
      return {
        
      }
    },
    methods: {
      openDrawer(index){
        this.components.nav_drawer.product_index=index;
        this.components.nav_drawer.mini_variant=false;
        this.components.nav_drawer.expand_on_hover=false;
        
      },
    },
    computed: {
      ...mapGetters({
        user: "user",
        components: "components"
      })
    } 
  }
</script>

